import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "container",
  class: "vue-lb-container"
}
const _hoisted_2 = { class: "vue-lb-content" }
const _hoisted_3 = { class: "vue-lb-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = ["title"]
const _hoisted_6 = ["srcset", "alt"]
const _hoisted_7 = ["width", "height", "autoplay"]
const _hoisted_8 = ["src", "type"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "vue-lb-footer" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "vue-lb-footer-info" }, null, -1)
const _hoisted_12 = { class: "vue-lb-footer-count" }
const _hoisted_13 = { class: "vue-lb-thumbnail-wrapper" }
const _hoisted_14 = {
  key: 0,
  class: "vue-lb-thumbnail"
}
const _hoisted_15 = ["title"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_LeftArrowIcon = _resolveComponent("LeftArrowIcon")!
  const _component_VideoIcon = _resolveComponent("VideoIcon")!
  const _component_RightArrowIcon = _resolveComponent("RightArrowIcon")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeLightBox && _ctx.closeLightBox(...args)), ["stop"]))
  }, [
    _createVNode(_Transition, {
      mode: "out-in",
      name: "vue-lb-content-transition",
      onAfterEnter: _ctx.enableImageTransition,
      onBeforeLeave: _ctx.disableImageTransition
    }, {
      default: _withCtx(() => [
        (_ctx.media)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  (_ctx.closable)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        title: _ctx.closeText,
                        class: "vue-lb-button-close"
                      }, [
                        _renderSlot(_ctx.$slots, "close", {}, () => [
                          _createVNode(_component_CloseIcon)
                        ])
                      ], 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: "vue-lb-figure",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createVNode(_Transition, {
                    mode: "out-in",
                    name: _ctx.modalImageTransitionName
                  }, {
                    default: _withCtx(() => [
                      (_ctx.media[_ctx.select].type !== 'video')
                        ? _withDirectives((_openBlock(), _createElementBlock("img", {
                            key: _ctx.media[_ctx.select].src,
                            srcset: _ctx.media[_ctx.select].srcset || '',
                            class: "vue-lb-modal-image",
                            alt: _ctx.media[_ctx.select].caption
                          }, null, 8, _hoisted_6)), [
                            [_directive_lazy, {
                  src: _ctx.media[_ctx.select].src,
                  loading: _ctx.media[_ctx.select].src,
                  error: _ctx.media[_ctx.select].src,
                }]
                          ])
                        : (_openBlock(), _createElementBlock("video", {
                            ref: "video",
                            key: _ctx.media[_ctx.select].sources[0].src,
                            width: _ctx.media[_ctx.select].width,
                            height: _ctx.media[_ctx.select].height,
                            autoplay: _ctx.media[_ctx.select].autoplay,
                            controls: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.media[_ctx.select].sources, (source) => {
                              return (_openBlock(), _createElementBlock("source", {
                                key: source.src,
                                src: source.src,
                                type: source.type
                              }, null, 8, _hoisted_8))
                            }), 128))
                          ], 8, _hoisted_7))
                    ]),
                    _: 1
                  }, 8, ["name"]),
                  _renderSlot(_ctx.$slots, "customCaption", {}, () => [
                    _withDirectives(_createElementVNode("div", {
                      class: "vue-lb-info",
                      innerHTML: _ctx.media[_ctx.select].caption
                    }, null, 8, _hoisted_9), [
                      [_vShow, _ctx.showCaption]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("div", _hoisted_12, [
                      _renderSlot(_ctx.$slots, "footer", {
                        current: _ctx.select + 1,
                        total: _ctx.media.length
                      }, () => [
                        _createTextVNode(_toDisplayString(_ctx.select + 1) + " / " + _toDisplayString(_ctx.media.length), 1)
                      ])
                    ], 512), [
                      [_vShow, _ctx.showFooterCount]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.showThumbs)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_ctx.media.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "vue-lb-thumbnail-arrow vue-lb-thumbnail-left",
                            title: _ctx.previousThumbText,
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.previousImage()), ["stop"]))
                          }, [
                            _renderSlot(_ctx.$slots, "previousThumb", {}, () => [
                              _createVNode(_component_LeftArrowIcon)
                            ])
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imagesThumb, (image, index) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          key: typeof image.src === 'string' ? `${image.src}${index}` : index,
                          class: _normalizeClass('vue-lb-modal-thumbnail' + (_ctx.select === index ? '-active' : '')),
                          onClick: _withModifiers(($event: any) => (_ctx.showImage(index)), ["stop"])
                        }, [
                          (image.type)
                            ? _renderSlot(_ctx.$slots, "videoIcon", { key: 0 }, () => [
                                _createVNode(_component_VideoIcon)
                              ])
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_16)), [
                          [_vShow, index >= _ctx.thumbIndex.begin && index <= _ctx.thumbIndex.end],
                          [_directive_lazy, image, "background-image"]
                        ])
                      }), 128)),
                      (_ctx.media.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "vue-lb-thumbnail-arrow vue-lb-thumbnail-right",
                            title: _ctx.nextThumbText,
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.nextImage()), ["stop"]))
                          }, [
                            _renderSlot(_ctx.$slots, "nextThumb", {}, () => [
                              _createVNode(_component_RightArrowIcon)
                            ])
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.media.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "vue-lb-arrow vue-lb-left",
                    title: _ctx.previousText,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.previousImage()), ["stop"]))
                  }, [
                    _renderSlot(_ctx.$slots, "previous", {}, () => [
                      _createVNode(_component_LeftArrowIcon)
                    ])
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true),
              (_ctx.media.length > 1)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "vue-lb-arrow vue-lb-right",
                    title: _ctx.nextText,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.nextImage()), ["stop"]))
                  }, [
                    _renderSlot(_ctx.$slots, "next", {}, () => [
                      _createVNode(_component_RightArrowIcon)
                    ])
                  ], 8, _hoisted_19))
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, _ctx.lightBoxOn]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onAfterEnter", "onBeforeLeave"])
  ]))
}